import Swiper, { Autoplay, Navigation, Pagination } from "swiper";
import "swiper/css";
import 'swiper/css/navigation';

export const cWebFunc = () => {
  const swiper = new Swiper('#loan-slide', {
    modules: [Navigation],
    slidesPerView: "auto",
    spaceBetween: 32,
    breakpoints: {
      768: {
        slidesPerView: 4,
      }
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });

  $('.c-web #side-btn-close').on('click', function() {
    $(this).parent('.side-btn').fadeOut();
  });
}
